import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import ContestDetail from '@/views/ContestDetail.vue'
import Question from '@/views/Question.vue'
import Exam from '@/views/Exam.vue'
import ExamRecord from '@/views/ExamRecord.vue'
import ExamRecordDetail from '@/views/ExamRecordDetail.vue'
import Result from '@/views/Result.vue'
import Favorite from '@/views/Favorite.vue'
import FavoriteDetail from '@/views/FavoriteDetail.vue'
import Profile from '@/views/Profile.vue'
import ActivityDetail from '@/views/ActivityDetail.vue'

Vue.use(VueRouter)

// 解决重复导航报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/contest',
    name: 'ContestDetail',
    component: ContestDetail
  },
  {
    path: '/question/:sectionId',
    name: 'Question',
    component: Question
  },
  {
    path: '/exam/:examId',
    name: 'Exam',
    component: Exam
  },
  {
    path: '/exam-record',
    name: 'ExamRecord',
    component: ExamRecord
  },
  {
    path: '/exam-record-detail/:recordId',
    name: 'ExamRecordDetail',
    component: ExamRecordDetail
  },
  {
    path: '/result',
    name: 'Result',
    component: Result
  },
  {
    path: '/favorite',
    name: 'Favorite',
    component: Favorite
  },
  {
    path: '/favorite-detail/:questionId',
    name: 'FavoriteDetail',
    component: FavoriteDetail
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/activity/:id',
    name: 'ActivityDetail',
    component: ActivityDetail
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫 - 强制登录
router.beforeEach((to, from, next) => {
  const userInfo = localStorage.getItem('userInfo')
  if (to.path !== '/login' && !userInfo) {
    next('/login')
  } else {
    next()
  }
})

export default router
